export default function Projects() {
    return (
        <div class="flex flex-col justify-center">
            <div class="flex flex-col lg:flex-row font-sans m-5 text-center border-solid border-2 border-black rounded-md">
                <div class="basis-2/3 mx-2 p-3">
                    <p>
                        <b>Project Name:</b> BuzzNet (Internatl Testing Phrase)
                    </p>
                    <p>
                        <b>Link (Apple):</b>{" "}
                        <a
                            href="https://testflight.apple.com/join/VjZGZZnS"
                        >
                            Click
                        </a>
                    </p>
                    <p>
                        <b>Link (Android) (Email needed to be added to tester list):</b>{" "}
                        <a
                            href="https://play.google.com/store/apps/details?id=com.andrewroar.BeeNet"
                        >
                            Click
                        </a>
                    </p>
                    <p>
                        <b>Description:</b> Free Business Networking App
                    </p>
                </div>
            </div>
        </div>
    );
}
